"use strict";

/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Fragments.
//
exports.CHAR = "\x01-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.RESTRICTED_CHAR = "\x01-\b\x0B\f\x0E-\x1F\x7F-\x84\x86-\x9F";
exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.RESTRICTED_CHAR_RE = new RegExp("^[" + exports.RESTRICTED_CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */
exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */
function isChar(c) {
  return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */
function isRestrictedChar(c) {
  return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}
exports.isRestrictedChar = isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */
function isCharAndNotRestricted(c) {
  return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
exports.isCharAndNotRestricted = isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */
function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}
exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */
// tslint:disable-next-line:cyclomatic-complexity
function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */
function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3htbC8xLjEvZWQyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOztBQUFBOzs7Ozs7Ozs7O0FBUUE7QUFDQTtBQUNBO0FBQ2EsWUFBSSxHQUFHLG1EQUFnRDtBQUV2RCx1QkFBZSxHQUMxQiwwQ0FBa0U7QUFFdkQsU0FBQyxHQUFHLFNBQVM7QUFFMUI7QUFDYSx1QkFBZSxHQUFHLHVLQUEySztBQUU3TCxpQkFBUyxHQUNwQixNQUFJLHVCQUFlLHVDQUFzQztBQUUzRDtBQUNBO0FBQ0E7QUFFYSxlQUFPLEdBQUcsSUFBSSxNQUFNLENBQUMsT0FBSyxZQUFJLE9BQUksRUFBRSxHQUFHLENBQUM7QUFFeEMsMEJBQWtCLEdBQUcsSUFBSSxNQUFNLENBQUMsT0FBSyx1QkFBZSxPQUFJLEVBQUUsR0FBRyxDQUFDO0FBRTlELFlBQUksR0FBRyxJQUFJLE1BQU0sQ0FBQyxPQUFLLFNBQUMsUUFBSyxFQUFFLEdBQUcsQ0FBQztBQUVuQywwQkFBa0IsR0FBRyxJQUFJLE1BQU0sQ0FBQyxPQUFLLHVCQUFlLE9BQUksRUFBRSxHQUFHLENBQUM7QUFFOUQsb0JBQVksR0FBRyxJQUFJLE1BQU0sQ0FBQyxPQUFLLGlCQUFTLE9BQUksRUFBRSxHQUFHLENBQUM7QUFFbEQsZUFBTyxHQUFHLElBQUksTUFBTSxDQUFDLE9BQUssdUJBQWUsVUFBSyxpQkFBUyxRQUFLLEVBQUUsR0FBRyxDQUFDO0FBRWxFLGtCQUFVLEdBQUcsSUFBSSxNQUFNLENBQUMsT0FBSyxpQkFBUyxRQUFLLEVBQUUsR0FBRyxDQUFDO0FBRTlELElBQU0sR0FBRyxHQUFHLENBQUM7QUFDYixJQUFNLEVBQUUsR0FBRyxHQUFHO0FBQ2QsSUFBTSxFQUFFLEdBQUcsR0FBRztBQUNkLElBQU0sS0FBSyxHQUFHLElBQUk7QUFFbEI7QUFDQTtBQUNBO0FBRUE7QUFDYSxjQUFNLEdBQUcsQ0FBQyxLQUFLLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxHQUFHLENBQUM7QUFFMUM7Ozs7Ozs7QUFPQSxTQUFnQixNQUFNLENBQUMsQ0FBUztFQUM5QixPQUFRLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU0sSUFDL0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksT0FBTyxJQUFJLENBQUMsSUFBSSxRQUFTO0FBQ25DO0FBSkE7QUFNQTs7Ozs7OztBQU9BLFNBQWdCLGdCQUFnQixDQUFDLENBQVM7RUFDeEMsT0FBUSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsSUFBSSxHQUFHLElBQzFCLENBQUMsS0FBSyxHQUFHLElBQ1QsQ0FBQyxLQUFLLEdBQUcsSUFDUixDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsSUFBSSxJQUFLLElBQ3RCLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxJQUFJLElBQUssSUFDdkIsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksSUFBSztBQUM1QjtBQVBBO0FBU0E7Ozs7Ozs7Ozs7O0FBV0EsU0FBZ0Isc0JBQXNCLENBQUMsQ0FBUztFQUM5QyxPQUFRLENBQUMsS0FBSyxHQUFHLElBQ2QsQ0FBQyxLQUFLLEdBQUksSUFDVixDQUFDLEtBQUssR0FBSSxJQUNWLENBQUMsR0FBRyxJQUFJLElBQUksQ0FBQyxHQUFHLElBQUssSUFDckIsQ0FBQyxLQUFLLElBQUssSUFDWCxDQUFDLEdBQUcsSUFBSSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQ3hCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE9BQU8sSUFBSSxDQUFDLElBQUksUUFBUztBQUNuQztBQVRBO0FBV0E7Ozs7Ozs7QUFPQSxTQUFnQixHQUFHLENBQUMsQ0FBUztFQUMzQixPQUFPLENBQUMsS0FBSyxLQUFLLElBQUksQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxHQUFHO0FBQ3pEO0FBRkE7QUFJQTs7Ozs7OztBQU9BO0FBQ0EsU0FBZ0IsZUFBZSxDQUFDLENBQVM7RUFDdkMsT0FBUyxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsSUFBSSxJQUFJLElBQ3RCLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxJQUFJLElBQUssSUFDeEIsQ0FBQyxLQUFLLElBQUksSUFDVixDQUFDLEtBQUssSUFBSSxJQUNWLENBQUMsS0FBSyxNQUFNLElBQ1osQ0FBQyxLQUFLLE1BQU0sSUFDWCxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsSUFBSSxJQUFLLElBQ3ZCLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxJQUFJLElBQUssSUFDdkIsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU8sSUFDM0IsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTyxJQUMzQixDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxPQUFPLElBQUksQ0FBQyxJQUFJLE9BQVE7QUFDeEM7QUFsQkE7QUFvQkE7Ozs7Ozs7QUFPQSxTQUFnQixVQUFVLENBQUMsQ0FBUztFQUNsQyxPQUFPLGVBQWUsQ0FBQyxDQUFDLENBQUMsSUFDdEIsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksSUFBSyxJQUN4QixDQUFDLEtBQUssSUFBSSxJQUNWLENBQUMsS0FBSyxJQUFJLElBQ1YsQ0FBQyxLQUFLLElBQUksSUFDVCxDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFPLElBQzNCLENBQUMsSUFBSSxNQUFNLElBQUksQ0FBQyxJQUFJLE1BQU87QUFDaEM7QUFSQSIsImlnbm9yZUxpc3QiOltdfQ==